import { Image } from 'antd';
import classNames from 'classnames';

import { useAppSelector } from 'store';

import { useOptionStatus } from 'modules/mavzuli-test';

import { MathJaxContext } from 'components';

interface IProps {
  id?: number;
  label?: string;
  name?: string;
  image?: string;
  onSelect: () => void;
}

export const OptionItem = ({ id, label, name, image, onSelect }: IProps) => {
  const isAnswered = useAppSelector(({ topicTest }) => topicTest.isAnswered);
  const selectedOption = useAppSelector(({ topicTest }) => topicTest.selectedOption);
  const questions = useAppSelector(({ topicTest }) => topicTest.test?.test[0]?.questions);
  const currentQuestionIndex = useAppSelector(({ topicTest }) => topicTest.currentQuestionIndex);

  const question = questions?.[currentQuestionIndex as number];

  const { isSuccess, isWrong } = useOptionStatus({
    optionId: id,
    question,
    selectedOption,
    isAnswered
  });

  return (
    <div
      onClick={onSelect}
      className={classNames('cursor-pointer rounded-xl border-2 transition-colors', {
        'border-gray-200 hover:bg-gray-50': !isSuccess && !isWrong,
        '!border-green-500 !bg-green-50': isSuccess,
        '!border-red-500 !bg-red-50': isWrong
      })}
    >
      <div className="flex items-center gap-3 rounded-xl p-3">
        <span className="text-lg font-semibold text-gray-600">{label?.toLowerCase()})</span>
        <p className="text-sm text-gray-800 whitespace-pre-line">
          <MathJaxContext expression={name} />
        </p>

        {image && (
          <div className="mt-4 flex justify-center">
            <Image
              loading="lazy"
              src={image}
              alt={name}
              title="Test image"
              className="!rounded-xl"
              width={150}
              height={150}
            />
          </div>
        )}
      </div>
    </div>
  );
};
